import './Modal.scss';

import Icon from './../../filter-components/Icon/Icon';
import PropTypes from 'prop-types';
import React from 'react';

class Modal extends React.PureComponent {

  static propTypes = {
    children: PropTypes.node,
    className: PropTypes.string,
    onClose: PropTypes.func
  };

  // UNSAFE_componentWillMount () {
  //   document.body.classList.add('modal-open');
  // }

  // componentWillUnmount () {
  //   document.body.classList.remove('modal-open');
  // }

  render () {
    const { className, onClose } = this.props;
    return (
      <div className={['modal--overlay', className].join(' ')}>
        <div className='modal--container'>
          {onClose && (
            <div className='modal--button-bar'>
              <button className='close-btn' onClick={onClose}>
                <Icon name='cross' />
              </button>
            </div>
          )}
          <div className='modal--content'>{this.props.children}</div>
        </div>
      </div>
    );
  }
}

export default Modal;
